import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store/index.js";

Vue.config.devtools = true;
Vue.config.productionTip = false;

// 风控
import "@/utils/passport";
import cc from "./utils/common";
// 风控初始化
$.loadMod([
  cc.config.dfpDomain + "/dfprs-collect/dist/fp.js?appCode=oL5SyeefiMStfRSe",
  cc.config.mmdsDomain + "/mmds/mmds.js?appCode=oL5SyeefiMStfRSe"
]);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
